import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import {
  DataService as CoreDataService,
  ObjectKey,
  PersistenceService,
  PersistMode,
  PersistObjectModel,
  QueryColumn,
  QueryColumnSortOrder,
  TargetColumnValue,
  TargetObjectData,
} from '@barthauer/abc/core/data';
import {
  AbcContextMenuComponent,
  AbcDateBoxComponent,
  AbcGridComponent,
  AbcPopupComponent,
  AbcSpeedDialActionComponent,
  AbcTextBoxComponent,
  _AbcButtonComponent,
  _AbcContextMenuComponent,
  _AbcFormComponent,
  _AbcGridComponent,
  _AbcTextAreaComponent,
} from '@barthauer/abc/ui-components';
import { UserService } from '@barthauer/basys/core/authentication';
import { DefaultIcons, Project } from '@barthauer/custom/xmt-models';
import {
  DxButtonModule,
  DxContextMenuModule,
  DxDataGridModule,
  DxDateBoxModule,
  DxFormModule,
  DxPopupModule,
  DxSpeedDialActionModule,
  DxTagBoxModule,
  DxTileViewModule,
} from 'devextreme-angular';
import { DxiItemModule } from 'devextreme-angular/ui/nested';
import DataSource from 'devextreme/data/data_source';
import { Column } from 'devextreme/ui/data_grid';
import { Subscription } from 'rxjs';
import {  NotificationMessage, PermessionType,ToastType } from '../models/enumeration-list.model';
import { AppService } from '../services/app.service';
import { DataService, ObjectKeys } from '../services/data.service';
import { NotificationService } from '../services/notification.service';
import { SharedModule } from '../shared/shared.module';
import { first } from 'rxjs/operators';
import { CheckPermissionDirective } from '../directives/check-permession-directive';

@Component({
  selector: 'ubt-geods-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FlexLayoutModule,
    CommonModule,
    DxPopupModule,
    DxTileViewModule,
    DxContextMenuModule,
    DxSpeedDialActionModule,
    AbcSpeedDialActionComponent,
    _AbcButtonComponent,
    DxTagBoxModule,
    DxButtonModule,
    DxiItemModule,
    DxDateBoxModule,
    SharedModule,
    _AbcGridComponent,
    DxDataGridModule,
    AbcDateBoxComponent,
    AbcTextBoxComponent,
    DxFormModule,
    _AbcFormComponent,
    AbcPopupComponent,
    _AbcTextAreaComponent,
    _AbcContextMenuComponent,
    CheckPermissionDirective
  ],
  standalone: true,
})
export class HomeComponent implements OnInit, OnDestroy {
  @ViewChild('form') form: _AbcFormComponent;
  @ViewChild('createProjectpopup') createProjectpopup: AbcPopupComponent;
  @ViewChild('deleteProjectpopup') deleteProjectpopup: AbcPopupComponent;
  @ViewChild('deleteContextMenu') deleteContextMenu: AbcContextMenuComponent;
  @ViewChild('contextMenu') contextMenu: _AbcContextMenuComponent;
  @ViewChild('projectGrid') projectGrid: AbcGridComponent;
  public userName: string;
  private subscriptions: Subscription[] = [];
  public projectList: Project[] = [];
  public isUpdating: boolean;
  public filtredSubprojects: DataSource;
  public project = new Project(null);
  public oldValueOfStartDate = new Date();
  public oldValueOfEndDate = new Date();
  public oldValueOfDesignation = '';
  public oldValueOfState = '';
  public oldValueOfDescription = '';
  public title = this.dataService.res('Ubt-Project-Create');
  public projectTitle: string;
  public mesureTaskLabel: string;
  public Action= PermessionType
  public noDataText = this.dataService.res('Ubt-No-Data-text');
  public filterPanelLabel = this.dataService.res('Ubt-Filter-Project');
  public projectColumns = [
    this.coreDataService.createQueryColumn('Id', 'Id', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn('Designation', 'Label', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn('ref:ParentId', 'ParentAddress', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn('SysDateInsert', 'Date', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn('Description', 'Description', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn('StartDate', 'StartDate', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn('EndDate', 'EndDate', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn('State', 'State', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn('Count(subProjects)', 'subProjectsCount', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn('Count(subProjects.Measures)', 'measuresCount', QueryColumnSortOrder.None),
    this.coreDataService.createQueryColumn(
      'Count(subProjects.Measures.MeasureTasks)',
      'tasksCount',
      QueryColumnSortOrder.None
    ),
  ];
  
  public columnsHeader: Column[] = [
    {
      caption: this.dataService.res('Ubt-Project-Name'),
      dataField: 'Label',
      dataType: 'string',
      visibleIndex: 0,
    },
    {
      caption: this.dataService.res('Ubt-MeasureDetail-Description'),
      dataField: 'Description',
      dataType: 'string',
      visibleIndex: 1,
    },
    {
      caption: this.dataService.res('Ubt-Measure-List-StartDate'),
      dataField: 'StartDate',
      dataType: 'date',
      format: 'dd.MM.yyyy',
      visibleIndex: 2,
    },
    {
      caption: this.dataService.res('Ubt-MeasureTask-State'),
      dataField: 'State',
      dataType: 'number',
      alignment: 'left',
      visibleIndex: 3,
    },
    {
      caption: this.dataService.res('Ubt-Measure-List-EndDate'),
      dataField: 'EndDate',
      dataType: 'date',
      format: 'dd.MM.yyyy',
      visibleIndex: 4,
    },
    {
      type: 'buttons',
      caption: '',
      alignment: 'left',
      dataField: '',
      visibleIndex: 5,
      minWidth: 50,
      width: '50px',
    },
  ];

  public createButtonOptions = {
    text: this.dataService.res('Ubt-CreateMeasure-Create'),
    useSubmitBehavior: true,
  };
  public updateButtonOptions = {
    text: this.dataService.res('Ubt-CreateMeasure-Update'),
    useSubmitBehavior: true,
  };
  public cancelButtonOptions = {
    text: this.dataService.res('Ubt-CreateMeasure-Cancel'),
    onClick: () => {
      this.closeCreatePopUp();
    },
  };
  public contextMenuItems: any[] = [
    {
      text: this.dataService.res('Ubt-Roles-Edit-Project'),
      onClick: (event) => {
        this.openProjectDialog();
      },
    },
    {
      text: this.dataService.res('Ubt-Roles-Delete-Project'),
      onClick: (event) => {
        this.openDeleteProjectDialog(event);
      },
    },
  ];

  public readonly exportFileName =
    this.dataService.res('Ubt-TreeList-Project') + '_' + this.datePipe.transform(new Date(), 'dd.MM.yyyy');

  constructor(
    private coreDataService: CoreDataService,
    private userService: UserService,
    public dataService: DataService,
    private appService: AppService,
    private persistenceService: PersistenceService,
    private cdr: ChangeDetectorRef,
    private datePipe: DatePipe,
    private notificationService: NotificationService
  ) {
    this.projectTitle = this.dataService.res('Ubt-TreeList-Project');
    this.mesureTaskLabel = this.dataService.res('Ubt-MeasureTask-Label');
    this.filterPanelLabel = this.dataService.res('Ubt-Filter-Project');
  }

  public ngOnInit(): void {
    
  

    this.subscriptions.push(
      this.dataService.updateGridData$.subscribe((companyId) => {
        this.getProjectsData(companyId);
      })
    );

    if (localStorage.getItem('currentCompany')) {
      this.getProjectsData(localStorage.getItem('currentCompany'));
    }
  }

  public onCellPrepared(e) {
    if (e.rowType === 'data' && e.column.type === 'buttons') {
      e.cellElement.style.cursor = 'pointer';
      e.cellElement.innerHTML = DefaultIcons.CONTEXTMENU;
    }
  }

  public onCellClick(e) {
    this.project = e.data;
    if (e.rowType === 'data' && e.column.type === 'buttons') {
      e.cellElement.className = 'context-menu-icon' + e.rowIndex;
      e.cellElement.innerHTML = this.contextMenu.visible ? DefaultIcons.CLOSE : DefaultIcons.CONTEXTMENU;
      this.contextMenuItems[0].visible=this.dataService.hasPermessionForSpecificModule('Project', PermessionType.UPDATE)
      this.contextMenuItems[1].visible=this.dataService.hasPermessionForSpecificModule('Project', PermessionType.DELETE)
      this.contextMenu.target = '.context-menu-icon' + e.rowIndex;
      this.contextMenu.instance.show();
    }
  }

  private getProjectsData(companyId: string) {
    this.appService.showLoader(true);
    const opath = 'ParentId=' + "'" + companyId + "'";
    this.dataService.readObjects<Project[]>(ObjectKeys.PROJECT, this.projectColumns, opath).subscribe(
      (projects) => {
        if (Array.isArray(projects) && projects.length > 0) {
          this.projectList = projects;
        } else {
          this.projectList = [];
          this.notificationService.callNotification({ message: NotificationMessage.Empty, type: ToastType.INFO });
        }
      },
      (error) => {
        console.error(error);
        this.appService.showLoader(false);
        this.cdr.markForCheck();
      },
      () => {
        this.appService.showLoader(false);
        this.cdr.markForCheck();
      }
    );
  }

  public openDeleteProjectDialog(event): void {
    this.deleteProjectpopup.instance.show();
  }

  public openProjectDialog() {
    this.isUpdating = true;
    this.title = this.dataService.res('Ubt-Project-Update');
    this.cdr.markForCheck();
    this.oldValue(true);
  }

  public oldValue(isUpdate?: boolean): void {
    this.isUpdating = isUpdate;
    this.oldValueOfDesignation = this.project.Label;
    this.oldValueOfStartDate = this.project.StartDate;
    this.oldValueOfEndDate = this.project.EndDate;
    this.oldValueOfState = this.project.State;
    this.oldValueOfDescription = this.project.Description;
    this.createProjectpopup.instance.show();
  }

  private closeCreatePopUp(persist?: boolean) {
    if (!persist) {
      if (this.isUpdating) {
        this.project.Label = this.oldValueOfDesignation;
        this.project.Description = this.oldValueOfDescription;
        this.project.State = this.oldValueOfState;
        this.project.StartDate = this.oldValueOfStartDate;
        this.project.EndDate = this.oldValueOfEndDate;
        this.isUpdating = false;
      }
    }
    this.project = new Project(null);
    this.isUpdating = false;
    this.form.instance.resetValues();
    this.title = this.dataService.res('Ubt-Project-Create');
    this.createProjectpopup.instance.hide();
  }

  public confirmRemoveProject(e): void {
    this.subscriptions.push(
      this.dataService.deleteObject(ObjectKeys.PROJECT, this.project.Id).subscribe(
        () => {
          this.notificationService.callNotification({
            message: NotificationMessage.ValidDeleteMessage,
            type: ToastType.SUCCESS,
          });
          const index = this.projectList.findIndex((item) => item.Id === this.project.Id);
          this.projectList.splice(index, 1);
          this.deleteProjectpopup.instance.hide();
        },
        (error) => {
          console.error(error);
          this.notificationService.callNotification({ message: NotificationMessage.Error, type: ToastType.ERROR });
        },
        () => {
          this.cdr.markForCheck();
        }
      )
    );
  }

  public abort(): void {
    this.project.Id = undefined;
    this.deleteProjectpopup.instance.hide();
  }

  public openCreateProject() {
    this.isUpdating = false;
    this.createProjectpopup.instance.show();
    this.project = new Project(null);
  }

  public createProject(e) {
    if (this.isUpdating === false) {
      e.preventDefault();
      this.persistProject(PersistMode.Insert);
    } else {
      this.persistProject(PersistMode.Update);
      e.preventDefault();
    }
  }

  private persistProject(mode: PersistMode): void {
    const projectPersistQuery: TargetObjectData = new TargetObjectData();
    projectPersistQuery.ObjectKey = new ObjectKey();
    projectPersistQuery.ObjectKey.ObjectType = ObjectKeys.PROJECT;
    const projectColumns: TargetColumnValue[] = [
      { Name: 'ParentId', Value: localStorage.getItem('currentCompany') },
      { Name: 'Designation', Value: this.project.Label },
      { Name: 'Description', Value: this.project.Description },
      { Name: 'StartDate', Value: this.datePipe.transform(this.project.StartDate, 'yyyy-MM-dd') },
      { Name: 'EndDate', Value: this.datePipe.transform(this.project.EndDate, 'yyyy-MM-dd') },
      { Name: 'State', Value: this.project.State },
    ];
    if (mode == PersistMode.Update) projectPersistQuery.ObjectKey.Id = this.project.Id;
    projectPersistQuery.Mode = mode;
    projectPersistQuery.TargetColumns = projectColumns;
    const persistObject: PersistObjectModel = new PersistObjectModel();
    persistObject.Object = projectPersistQuery;
    this.subscriptions.push(
      this.persistenceService.executePersistObjectQuery(persistObject).subscribe(
        (data: any) => {
          if (!this.isUpdating) {
            this.getLatestProject(data.Id);
          }
          this.notificationService.callNotification({
            message: NotificationMessage.ValidInsertMessage,
            type: ToastType.SUCCESS,
          });
        },
        (error) => {
          this.notificationService.callNotification({ message: NotificationMessage.Error, type: ToastType.ERROR });
        },
        () => {
          this.closeCreatePopUp(true);
          this.project = new Project(null);
        }
      )
    );
  }

  public getLatestProject(id: string): void {
    this.appService.showLoader(true);
    const opath = `Id='${id}'`;
    this.dataService.readObjects<Project[]>(ObjectKeys.PROJECT, this.projectColumns, opath).subscribe(
      (projectData) => {
        this.projectList.push(projectData[0]);
        this.cdr.markForCheck();
      },
      (error) => {
        console.error(error);
        this.appService.showLoader(false);
      },
      () => {
        this.appService.showLoader(false);
      }
    );
  }

  public ngOnDestroy(): void {
    this.subscriptions.map((subscription) => subscription.unsubscribe());
  }
}
